// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dialog__header {\n  word-break: break-all;\n  word-wrap: break-word;\n  padding-right: 32px;\n}\n.intr-box {\n  display: flex;\n  margin-bottom: 20px;\n}\n.intr-box span {\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
